import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as N, useSlots as Z, computed as l, createBlock as x, openBlock as c, unref as V, normalizeClass as B, createSlots as ee, withCtx as L, createTextVNode as J, toDisplayString as G, renderSlot as K, createElementBlock as v, normalizeStyle as te, createCommentVNode as g, mergeProps as z, resolveDynamicComponent as F, createElementVNode as R, normalizeProps as ne, guardReactiveProps as ae, Fragment as oe, renderList as re } from "vue";
import { CdrButton as ie, CdrLink as le } from "@rei/cedar";
import { CdrColorTextLinkRest as k, CdrColorTextSecondary as ce, CdrColorTextPrimary as u, CdrColorTextInverse as o, CdrColorTextBrand as A, CdrColorTextSale as $, CdrColorBackgroundBrandSpruce as E, CdrColorBackgroundMessageSale as D, CdrColorBackgroundSecondary as j, CdrColorBackgroundPrimary as se } from "@rei/cdr-tokens";
import de from "@rei/landing-image-component";
const I = {
  contentPalettes: {
    primary: {
      eyebrow: u,
      heading: u,
      subheading: u,
      body: u,
      inlineLink: k,
      accentText: A,
      altLink: k,
      primaryCtaModifier: "primary",
      secondaryCtaModifier: "secondary"
    },
    inverse: {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "dark-secondary"
    },
    sale: {
      eyebrow: u,
      heading: $,
      subheading: $,
      body: u,
      inlineLink: k,
      accentText: $,
      altLink: k,
      primaryCtaModifier: "sale",
      secondaryCtaModifier: "secondary"
    },
    "sale-inverse": {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "sale"
    },
    brand: {
      eyebrow: u,
      heading: A,
      subheading: A,
      body: u,
      inlineLink: k,
      accentText: A,
      altLink: k,
      primaryCtaModifier: "primary",
      secondaryCtaModifier: "secondary"
    },
    "brand-inverse": {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "inverse-secondary"
    },
    "alt-sale": {
      eyebrow: u,
      heading: u,
      subheading: u,
      body: u,
      inlineLink: k,
      accentText: ce,
      altLink: k,
      primaryCtaModifier: "sale",
      secondaryCtaModifier: "secondary"
    }
  },
  surfacePalettes: {
    primary: {
      background: se,
      backgroundHover: j
    },
    secondary: {
      background: j,
      backgroundHover: j
    },
    sale: {
      background: D,
      backgroundHover: D
    },
    brand: {
      background: E,
      backgroundHover: E
    },
    dark: {
      background: "#0c0b08bf",
      backgroundHover: "#0c0b08bf"
    }
  }
}, ue = (n = { content: "primary", surface: "primary" }) => ({
  cssSurfacePaletteVars: () => {
    const t = I.surfacePalettes[n.surface];
    return {
      "--palette-background-color": t == null ? void 0 : t.background,
      "--palette-background-hover-color": t == null ? void 0 : t.backgroundHover
    };
  },
  /*
  * These can be imported for sections that dont use content block but still need
  * content palette applied.
  */
  paletteCtaModifiers: () => {
    const t = I.contentPalettes[n.content];
    return {
      primaryCtaModifier: t.primaryCtaModifier,
      secondaryCtaModifier: t.secondaryCtaModifier
    };
  },
  cssContentPaletteVars: () => {
    const t = I.contentPalettes[n.content];
    return {
      "--palette-eyebrow-color": t == null ? void 0 : t.eyebrow,
      "--palette-heading-color": t == null ? void 0 : t.heading,
      "--palette-subheading-color": t == null ? void 0 : t.subheading,
      "--palette-body-color": t == null ? void 0 : t.body,
      "--palette-inline-link-color": t == null ? void 0 : t.inlineLink,
      "--palette-accent-text-color": t == null ? void 0 : t.accentText,
      "--palette-alt-link-color": t == null ? void 0 : t.altLink
    };
  }
}), fe = /* @__PURE__ */ N({
  __name: "LandingAction",
  props: {
    modifier: {
      type: String,
      required: !1,
      default: "primary"
    },
    href: {
      type: String,
      required: !1,
      default: ""
    },
    target: {
      type: String,
      required: !1,
      default: ""
    },
    newTab: {
      type: Boolean,
      required: !1,
      default: !1
    },
    tag: {
      type: String,
      required: !1,
      default: "a"
    },
    text: {
      type: String,
      required: !1,
      default: ""
    },
    noFollow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    analyticsId: {
      type: String,
      required: !1,
      default: ""
    },
    ariaLabel: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(n) {
    const t = ["inverse-secondary", "dark-secondary"], a = Z(), p = (m) => {
      var b;
      return (b = a[m]) == null ? void 0 : b.call(a).length;
    }, d = n, S = l(() => d.ariaLabel ? d.ariaLabel : d.text), h = l(() => p("landing-action-icon")), H = l(() => d.modifier && !t.includes(d.modifier) ? d.modifier : void 0), T = l(() => `ls-content-block__action ${t.includes(d.modifier) ? `ls-content-block__action--${d.modifier} ` : ""}`);
    return (m, b) => (c(), x(V(ie), {
      class: B(T.value),
      modifier: H.value,
      href: n.href || n.target,
      target: n.newTab ? "_blank" : null,
      tag: n.tag || "a",
      rel: n.noFollow ? "nofollow" : null,
      "data-analytics-id": n.analyticsId ? n.analyticsId : null,
      "aria-label": S.value
    }, ee({
      default: L(() => [J(" " + G(n.text), 1)]),
      _: 2
    }, [h.value ? {
      name: "icon-left",
      fn: L(() => [K(m.$slots, "landing-action-icon", {}, void 0, !0)]),
      key: "0"
    } : void 0]), 1032, ["class", "modifier", "href", "target", "tag", "rel", "data-analytics-id", "aria-label"]));
  }
}), Q = (n, t) => {
  const a = n.__vccOpts || n;
  for (const [p, d] of t)
    a[p] = d;
  return a;
}, ge = /* @__PURE__ */ Q(fe, [["__scopeId", "data-v-66b30db1"]]), ye = {
  key: 0,
  class: "ls-content-block__region ls-content-block__region--top"
}, be = ["innerHTML"], ve = {
  key: 1,
  class: "ls-content-block__region ls-content-block__region--middle"
}, ke = ["innerHTML"], me = ["innerHTML"], pe = ["innerHTML"], he = {
  key: 2,
  class: "ls-content-block__region ls-content-block__region--bottom"
}, Ce = {
  key: 0,
  class: "ls-content-block__actions-container"
}, _e = /* @__PURE__ */ N({
  __name: "LandingContentBlock",
  props: {
    lockup: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    eyebrow: {
      type: String,
      required: !1,
      default: ""
    },
    heading: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    subheading: {
      type: String,
      required: !1,
      default: ""
    },
    body: {
      type: String,
      required: !1,
      default: ""
    },
    actions: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    visualConfiguration: {
      type: Object,
      required: !1,
      default: () => {
      }
    }
  },
  setup(n) {
    const t = {
      level: "h2",
      srOnly: !1,
      text: ""
    }, a = n, p = (e, r) => {
      const i = {}, s = ["xs", "sm", "md", "lg"];
      return s.forEach((f, C) => {
        i[`--${e}-${f}`] = r[f] || i[`--${e}-${[s[C - 1]]}`];
      }), i;
    }, d = (e) => {
      switch (e) {
        case "left":
          return "flex-start";
        case "right":
          return "flex-end";
        default:
          return "center";
      }
    }, S = l(() => {
      var e;
      return !!((e = a.lockup) != null && e.images);
    }), h = l(() => {
      var r, i;
      const e = ((i = (r = a.visualConfiguration) == null ? void 0 : r.palette) == null ? void 0 : i.content) || "primary";
      return ue({
        content: e
      });
    }), H = l(() => {
      const {
        textAlignment: e = {}
      } = a.visualConfiguration || {}, r = {};
      e && Object.keys(e).forEach((_) => {
        const w = e[_] || "left";
        r[_] = d(w);
      });
      const i = p("content-align", r), s = p("text-align", r), f = h == null ? void 0 : h.value.cssContentPaletteVars();
      return {
        ...i,
        ...s,
        ...f
      };
    }), T = l(() => {
      var e, r, i, s;
      return !!((r = (e = a.actions) == null ? void 0 : e.defaultActions) != null && r.length) || !!((s = (i = a.actions) == null ? void 0 : i.javascriptActions) != null && s.length);
    }), m = l(() => {
      var w;
      const {
        javascriptActions: e = [],
        defaultActions: r = []
      } = a.actions, {
        primaryCtaModifier: i,
        secondaryCtaModifier: s
      } = h.value.paletteCtaModifiers(), f = (w = a.actions) == null ? void 0 : w.allSecondaryButtons, C = e == null ? void 0 : e.map((O, P) => {
        const M = {
          ...O
        };
        return M.modifier = P === 0 && !f ? i : s, M;
      }), _ = r.map((O, P) => {
        const M = {
          ...O
        };
        return M.modifier = P === 0 && !f && !(e != null && e.length) ? i : s, M;
      });
      return {
        javascriptActions: C,
        defaultActions: _
      };
    }), b = l(() => {
      const {
        alternateLink: e
      } = a.actions || {};
      return (e == null ? void 0 : e.href) && (e == null ? void 0 : e.text) ? e : null;
    }), y = l(() => ({
      ...t,
      ...a.heading
    })), q = l(() => {
      let e;
      const r = ["h2", "h3", "h4", "h5", "h6"];
      if (!y.value.text)
        e = y.value.level;
      else if (y.value.level) {
        const i = r.indexOf(y.value.level);
        e = i < 3 ? r[i + 1] : "span";
      }
      return {
        level: e || t.level,
        text: a.subheading
      };
    }), U = l(() => !!y.value.srOnly), W = l(() => !!S.value || !!a.eyebrow), X = l(() => {
      var e;
      return !!((e = a == null ? void 0 : a.heading) != null && e.text) || !!a.subheading || !!a.body;
    }), Y = l(() => !!T.value || !!b.value);
    return (e, r) => {
      var i, s, f;
      return c(), v("div", {
        style: te(H.value),
        class: B(["ls-content-block", `ls-content-block--${((i = n.visualConfiguration) == null ? void 0 : i.contentSize) || "md"}`])
      }, [W.value ? (c(), v("div", ye, [S.value ? (c(), x(V(de), z({
        key: 0,
        class: "ls-content-block__lockup"
      }, n.lockup, {
        "aria-hidden": U.value
      }), null, 16, ["aria-hidden"])) : g("", !0), n.eyebrow ? (c(), v("div", {
        key: 1,
        class: "ls-content-block__eyebrow",
        innerHTML: n.eyebrow
      }, null, 8, be)) : g("", !0)])) : g("", !0), X.value ? (c(), v("div", ve, [y.value.text ? (c(), x(F(y.value.level), {
        key: 0,
        class: B(["ls-content-block__heading", `ls-content-block__heading--${((s = n.visualConfiguration) == null ? void 0 : s.contentSize) || "md-standard"}`, {
          "ls-content-block__heading--sr-only": y.value.srOnly
        }])
      }, {
        default: L(() => [R("span", {
          innerHTML: y.value.text
        }, null, 8, ke)]),
        _: 1
      }, 8, ["class"])) : g("", !0), q.value.text ? (c(), x(F(q.value.level), {
        key: 1,
        class: B(["ls-content-block__subheading", `ls-content-block__subheading--has-heading-
              ${((f = n.visualConfiguration) == null ? void 0 : f.contentSize) || "md"}`])
      }, {
        default: L(() => [R("span", {
          innerHTML: q.value.text
        }, null, 8, me)]),
        _: 1
      }, 8, ["class"])) : g("", !0), n.body ? (c(), v("div", {
        key: 2,
        class: "ls-content-block__body",
        innerHTML: n.body
      }, null, 8, pe)) : g("", !0)])) : g("", !0), Y.value ? (c(), v("div", he, [T.value ? (c(), v("div", Ce, [K(e.$slots, "javascriptActions", ne(ae({
        javascriptActions: m.value.javascriptActions
      })), void 0, !0), (c(!0), v(oe, null, re(m.value.defaultActions, (C, _) => (c(), x(ge, z({
        key: _
      }, {
        ref_for: !0
      }, C), {
        "landing-action-icon": L(() => [...r[0] || (r[0] = [])]),
        _: 1
      }, 16))), 128))])) : g("", !0), b.value ? (c(), x(V(le), {
        key: 1,
        class: "ls-content-block__alternate-link",
        href: b.value.href,
        standalone: ""
      }, {
        default: L(() => [J(G(b.value.text), 1)]),
        _: 1
      }, 8, ["href"])) : g("", !0)])) : g("", !0)], 6);
    };
  }
}), Be = /* @__PURE__ */ Q(_e, [["__scopeId", "data-v-5164f460"]]);
export {
  ge as LandingAction,
  Be as LandingContentBlock
};
